import axiosClient from "@/api/common/axiosClient.ts";
import { Client } from "@/types/client.ts";

export const getClient = () => {
  return axiosClient.get<Client>("clients/current/");
};
